import React from "react";
import { Link } from "react-router-dom";

type AdminMenuProps = {
  email?: string | null;
  isOpen: boolean;
  onClose: () => void;
};

export const AdminMenu: React.FC<AdminMenuProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;
  return (
    <div
      className="absolute right-0 mt-2 w-48 rounded-xl border border-gray-200 bg-white shadow-lg ring-1 ring-black/5 z-40"
      role="menu"
      aria-label="Admin menu"
    >
      <div className="py-1 text-sm">
        <Link
          to="/admin"
          className="block px-4 py-2 hover:bg-gray-50"
          role="menuitem"
          onClick={onClose}
        >
          Dashboard
        </Link>
        <Link
          to="/admin/logs"
          className="block px-4 py-2 hover:bg-gray-50"
          role="menuitem"
          onClick={onClose}
        >
          Logs
        </Link>
        <Link
          to="/admin/users"
          className="block px-4 py-2 hover:bg-gray-50"
          role="menuitem"
          onClick={onClose}
        >
          User Management
        </Link>
      </div>
    </div>
  );
};

export default AdminMenu;

